const deprecatedWarn = (hookName, propName, newPropName) => {
  if (!propName) {
    console.warn(`"${hookName}" is deprecated.`);
    return;
  }
  console.warn(`[${hookName}]: "${propName}" prop is deprecated${newPropName ? `, please use ${newPropName} instead.` : "."}`);
};
export {
  deprecatedWarn
};
